<template>
	<circle v-if="circle" :cx="attrs.cx" :cy="attrs.cy" :r="attrs.r" fill="black"  />
	<rect v-else fill="black"
		:x="attrs.x" :y="attrs.y" :width="attrs.width" :height="attrs.height" :rx="attrs.rx" />
</template>

<script>
export default {
	name: 'SVGElementMask',
	props: {
		circle: {
			type: Boolean,
			default: false,
		},
		padding: {
			type: Number,
			requred: true,
		},
		rounded: {
			type: Number,
			requred: true,
		},
		windowWidth: {
			type: Number,
			requred: true,
		},
		windowHeight: {
			type: Number,
			requred: true,
		},
		targetWidth: {
			type: Number,
			required: true,
		},
		targetHeight: {
			type: Number,
			required: true,
		},
		targetTop: {
			type: Number,
			required: true,
		},
		targetLeft: {
			type: Number,
			required: true,
		},
	},
	computed: {
		rectSettings() {
			return {
				x: this.targetLeft - this.padding,
				y: this.targetTop - this.padding,
				width: this.targetWidth + (this.padding * 2),
				height: this.targetHeight + (this.padding * 2),
				rx: this.rounded,
			};
		},
		circleSettings() {
			const width = (this.targetWidth + this.padding);
			const height = (this.targetHeight + this.padding);

			return {
				cx: this.targetLeft + (this.targetWidth / 2),
				cy: this.targetTop + (this.targetHeight / 2),
				r: Math.max(width, height) / 2,
			};
		},
		attrs() {
			return this.circle ? this.circleSettings : this.rectSettings;
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/base/SVGElementMask.vue